import { render, staticRenderFns } from "./StockFailPopup.vue?vue&type=template&id=ace9a3f8&"
import script from "./StockFailPopup.vue?vue&type=script&lang=js&"
export * from "./StockFailPopup.vue?vue&type=script&lang=js&"
import style0 from "./StockFailPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports